export default __webpack_public_path__ + "static/media/Beard_5_C1.4f6e5f89.svg";